export const BASE_URL = 'http://fajob-env.eba-wxp6mi6a.ap-southeast-1.elasticbeanstalk.com/api';

export const SESSION_TYPE_ACTION = {
  HANDLER_TYPE_LOGIN: 'LOGIN',
  HANDLER_TYPE_LOGOUT: 'LOGOUT',
};

export const JOB_TYPE_ACTION = {
  HANDLER_GET_JOB: 'GET_JOB',
  HANDLER_GET_JOB_ID: 'GET_JOB_ID',
  HANDLE_UPDATE_JOB: 'UPDATE_JOB',
};
